import axios from 'axios';
import store from '@/store/store';

const instance = axios.create();
//instance.defaults.baseURL = 'https://apitest.mfu.ac.th/APIGraduateCeremony'; //api ตัวเทส2023 เวลาจะอัพให้บอกอาร์ท
//instance.defaults.baseURL = 'http://127.0.0.1:5000/'; //ในเครื่อง 29-11-2021
instance.defaults.baseURL = 'https://ccrapi.mfu.ac.th'; // ตัวจริงที่เป็น ลีนุก เวลาจะอัพให้บอกอาร์ท
//instance.defaults.baseURL = 'http://10.1.104.19';


instance.defaults.timeout = 15000;

instance.defaults.headers = {
  'Content-Type': 'application/json',
  'api-key': '12345678900987654321',
  'api-version': '1.0',
  Authorization: `Bearer ${store.state.token}`
};

export default {
  onSetHeader() {
    instance.defaults.headers = {
      'Content-Type': 'application/json',
      'api-key': '12345678900987654321',
      'api-version': '1.0',
      Authorization: `Bearer ${store.state.token}`
    };
  },

  onTopUpAdd(body) {
    return instance.post('topup', body, header);
  },
  apilogin(studentcode, birthday) {
    return instance.post('authen/APILogin/' + studentcode + '/' + birthday);
    // return instance.post('authen/APILogin/' + studentcode + '/' + birthday+ '/' +year);
  },
  keepalive() {
    return instance.post('authen/Keepalive');
  },
  //Student
  getSlip() {
    return instance.get('student/getslip/' + studentid);
  },
  getPostpone(studentid) {
    return instance.get('student/getpostpone/' + studentid);
  },
  getStudentUserQuestionById(studentid) {
    return instance.get('student/userquestion/' + studentid);
  },
  getStudentUserQuestionDetailById(studentid) {
    return instance.get('student/userquestiondetail/' + studentid);
  },
  // getSearch() {
  //   return instance.get("student/search");
  // },
  getStudentByID(studentid) {
    return instance.get('student/' + studentid);
  },
  getStudentByBirthday(studentcode, birthday) {
    return instance.get('student/birthday/' + studentcode + '/' + birthday);
  },
  // getStudentGeneral_62(studentid) {
  //   return instance.get('student/general_62/' + studentid);
  // },
  getStudentGeneral(studentid) {
    return instance.get('student/general/' + studentid);
  },
  getStudentGraduateStatus(studentid) {
    // console.log("api==",studentid)
    return instance.get('student/studentgraduate/' + studentid);
  },
  getStudentQuestionnaire(studentid, start, finish) {
    return instance.get('student/questionnaire/' + studentid + '/' + start + '/' + finish);
  },

  // getStudentPostById(studentid, thaistudent,year) {
  //   return instance.get('student/studentpost/' + studentid + '/' + thaistudent+ '/' +year);
  // },
  getStudentPostById(student) {
    // console.log("api==",student)
    return instance.get('student/studentpost/' + student.studentid + '/' + student.thaistudent )
  },
  getStudentPostById_80(student) {
    // console.log("api==",student)
    return instance.get('student/studentpost_80/' + student.studentid + '/' + student.thaistudent + '/' + student.year)
  },
  getStudentPostPay(studentid, thaistudent) {
    return instance.get('student/studentpostpay/' + studentid + '/' + thaistudent);
  },
  getStudentReportPostById(student) {
    return instance.get('student/studentreportpost/' + student.studentid + '/' + student.thaistudent + '/' + student.year)
  },
  getStudentReporConfirmById(student) {
    // console.log("s==",student)
    return instance.get('student/studentreportconfirm/' + student.studentid + '/' + student.thaistudent + '/' + student.current_postpone)
  },
  getStudentReportPostPay(studentid, thaistudent) {
    return instance.get('student/studentreportpostpay/' + studentid + '/' + thaistudent);
  },
  getPart10(studentid, qid) {
    return instance.get('student/getpart10/' + studentid + '/' + qid);
  },
  getAnsAllPart10(studentid) {
    return instance.get('student/getansallpart10/' + studentid );
  },
  getCountPart10(studentid) {
    return instance.get('student/getcountpart10/' + studentid );
  },
  getFuture(studentid) {
    return instance.get('student/getfuture/' + studentid );
  },
  updateStudentUserQuestion(body) {
    return instance.post('student/updateuserquestion', body);
  },
  updateStudentUserQuestion2(body) {
    return instance.post('student/updateuserquestion2', body);
  },
  updateStudentUserQuestion3(body) {
    return instance.post('student/updateuserquestion3', body);
  },
  updateStudentUserQuestion4(body) {
    return instance.post('student/updateuserquestion4', body);
  },
  updateStudentUserQuestion7(body) {
    return instance.post('student/updateuserquestion7', body);
  },
  postStudentUserQuestion(body) {
    return instance.post('student/postuserquestion', body);
  },
  postStudentUserQuestion2(body) {
    return instance.post('student/postuserquestion2', body);
  },
  postStudentUserQuestion3(body) {
    return instance.post('student/postuserquestion3', body);
  },
  postStudentUserQuestion4(body) {
    return instance.post('student/postuserquestion4', body);
  },
  postStudentUserQuestion7(body) {
    return instance.post('student/postuserquestion7', body);
  },
  postStudentConsent(body) {
    return instance.post('student/postconsent', body);
  },
  updateStudentConsent(body) {
    return instance.post('student/updateconsent', body);
  },
  postStudentGeneral(body) {
    // console.log("body==",body)
    return instance.post('student/postgeneral', body);
  },
  updateStudentGeneral(body) {
    // console.log("body==",body)
    return instance.post('student/updategeneral', body);
  },
  updateStudentPart1(body) {
    return instance.post('student/updatepart1', body);
  },
  updateStudentPart2(body) {
    return instance.post('student/updatepart2', body);
  },
  updateStudentPart2_20(body) {
    return instance.post('student/updatepart2_20', body);
  },
  updateStudentPart2_21(body) {
    return instance.post('student/updatepart2_21', body);
  },
  updateStudentPart2_3(body) {
    return instance.post('student/updatepart2_3', body);
  },
  updateStudentPart3(body) {
    return instance.post('student/updatepart3', body);
  },
  updateStudentPart4(body) {
    return instance.post('student/updatepart4', body);
  },
  updateStudentPart5(body) {
    return instance.post('student/updatepart5', body);
  },
  postStudentRegis(body) {
    return instance.post('student/postregis', body);
  },
  updateStudentRegis_62(body) {
    return instance.post('student/updateregis62', body);
  },
  updateStudentRegis(body) {
    return instance.post('student/updateregis', body);
  },
  postStudentQuestionnaire(body) {
    return instance.post('student/poststudentq', body);
  },
  updateStudentQuestionnaire(body) {
    return instance.post('student/updatestudentq', body);
  },
  updatePart10(body) {
    return instance.post('student/updatepart10', body);
  },
  postStudentPost(body) {
    return instance.post('student/poststudentpost', body);
  },
  updateStudentPost_62(body) {
    return instance.post('student/updatestudentpost62', body);
  },
  updateStudentPost(body) {
    return instance.post('student/updatestudentpost', body);
  },
  //Sysbytdes

  getRegisTypeID(thaistudent,id) {
    return instance.get('sysbytdes/regis/' + thaistudent+ '/' + id);
  },
  getRegisTypeAll(thaistudent) {
    return instance.get('sysbytdes/regisall/' + thaistudent);
  },
  getRegisTypeBetween(thaistudent, start, finish) {
    return instance.get('sysbytdes/regisbetween/' + thaistudent + '/' + start + '/' + finish);
  },
  getCountryNoThaiPost(countryid, thaistudent) {
    return instance.get('sysbytdes/countrynothaipost/' + thaistudent);
  },
  getCountryNoThai(thaistudent) {
    return instance.get('sysbytdes/countrynothai/' + thaistudent);
  },
  getCountryById(countryid, thaistudent) {
    return instance.get('sysbytdes/country/' + countryid + '/' + thaistudent);
  },
  getProvinceById(provinceid, thaistudent) {
    return instance.get('sysbytdes/province/' + provinceid + '/' + thaistudent);
  },
  getProvinceAll(thaistudent) {
    return instance.get('sysbytdes/provinceall/' + thaistudent);
  },
  getTopicAll() {
    return instance.get('sysbytdes/topicall');
  },
  getDistrictByDistrictid(districtid, thaistudent) {
    return instance.get('sysbytdes/districtbydistrictid/' + districtid + '/' + thaistudent);
  },
  getDistrictByid(proivinceid, thaistudent) {
    return instance.get('sysbytdes/district/' + proivinceid + '/' + thaistudent);
  },
  getSubDistrictBySubdistricid(subdistrictid, thaistudent) {
    return instance.get('sysbytdes/subdistrictbysubdistrictid/' + subdistrictid + '/' + thaistudent);
  },
  getSubDistrictByid(districtid, thaistudent) {
    return instance.get('sysbytdes/subdistrict/' + districtid + '/' + thaistudent);
  },
  getZipcode(subdistrictid, thaistudent) {
    return instance.get('sysbytdes/zipcode/' + subdistrictid + '/' + thaistudent);
  },
  getCountryAll(thaistudent) {
    return instance.get('sysbytdes/countryall/' + thaistudent);
  },
  getSybytedesByAns(columname, ansid, thaistudent) {
    return instance.get('sysbytdes/ans/' + columname + '/' + ansid + '/' + thaistudent);
  },
  getPostType(columname, thaistudent) {
    return instance.get('sysbytdes/posttype/' + columname + '/' + thaistudent);
  },
  getPostTypeBetween(columname, thaistudent, start, finish) {
    return instance.get('sysbytdes/posttypebetween/' + columname + '/' + thaistudent + '/' + start + '/' + finish);
  },
  getSybytedesByColumname(columname, thaistudent) {
    return instance.get('sysbytdes/columname/' + columname + '/' + thaistudent);
  },
  getPositionAll() {
    return instance.get('sysbytdes/positionall');
  },
  getPositionById(positionid) {
    return instance.get('sysbytdes/position/' + positionid);
  },
  getWorktypeAll() {
    return instance.get('sysbytdes/worktypeall/' + thaistudent);
  },
  getProgramEduAll(thaistudent) {
    return instance.get('sysbytdes/programeduall/' + thaistudent);
  },
  getProgramEduById(programid, thaistudent) {
    return instance.get('sysbytdes/program/' + programid + '/' + thaistudent);
  },
  // Question
  getQuestionaireStatus(studentid) {
    return instance.get('question/' + studentid);
  },
  getQuestionBySection(section, sex, thaistudent) {
    return instance.get('question/section/' + section + '/' + sex + '/' + thaistudent);
  },
  getAnsByQuestionID(questionid, thaistudent) {
    return instance.get('question/ans/' + questionid + '/' + thaistudent);
  },
  getQuestionByQuestionnaireID(questionnaireid, thaistudent, start, finish) {
    return instance.get('question/questionnaire/' + questionnaireid + '/' + thaistudent + '/' + start + '/' + finish);
  },
  getQuestionPart10(questionnaireid, thaistudent, start) {
    return instance.get('question/part10/' + questionnaireid + '/' + thaistudent + '/' + start );
  },
  getAnsPart10(id,thaistudent){
    return instance.get('question/anspart10/' + id + '/' + thaistudent  );
  },
  getAnsLoop(id, thaistudent, code) {
    return instance.get('question/ansloop/' + id + '/' + thaistudent + '/' + code );
  },
  getQuestionbetweenPart10(student) {
    // console.log("s==",student)
    return instance.get('question/betweenpart10/'  + student.thaistudent + '/' + student.start+ '/' + student.finish)
  },
  getStatisticDate() {
    return instance.get('statistic/bydate');
  },
  getStatisticAttend(thaistudent, facultyid, levelid) {
    return instance.get('statistic/attend/'+ thaistudent + '/' + facultyid + '/' + levelid);
  },
  getStatisticNotAttend(thaistudent, facultyid, levelid) {
    return instance.get('statistic/notattend/'+ thaistudent + '/' + facultyid + '/' + levelid);
  },
  getStatisticDate_62() {
    return instance.get('statistic/bydate_62');
  },
  getStatisticFaculty() {
    return instance.get('statistic/faculty');
  },
  getStatisticFaculty_62() {
    return instance.get('statistic/faculty_62');
  },
  getStatisticFaculty_63() {
    return instance.get('statistic/faculty_63');
  },
  getStatisticDept() {
    return instance.get('statistic/dept');
  }, getStatisticDept_62() {
    return instance.get('statistic/dep_62');
  },
  getStatisticByType(thaistudent, year) {
   // console.log("api==",thaistudent, year)
    return instance.get('statistic/bytype/' + thaistudent + '/' + year);
  },
  getExcelInCompleted(thaistudent, facultyid, levelid, deptid, groupid, year) {
    return instance.get('statistic/excelincompleted/' + thaistudent + '/' + facultyid + '/' + levelid + '/' + deptid + '/' + groupid + '/' + year);
  },
  getStatisticIn_Completed(thaistudent, facultyid, levelid, deptid, groupid, year) {
    // console.log("api==",thaistudent, facultyid, levelid, deptid, groupid, year)
    return instance.get('statistic/incompleted/' + thaistudent + '/' + facultyid + '/' + levelid + '/' + deptid + '/' + groupid + '/' + year);
  },
  getStatisticCompleted(thaistudent, facultyid, levelid, deptid, groupid, year) {
    return instance.get('statistic/completed/' + thaistudent + '/' + facultyid + '/' + levelid + '/' + deptid + '/' + groupid + '/' + year);
  },
  getExcelCompleted(thaistudent, facultyid, levelid, deptid, groupid, year) {
    return instance.get('statistic/excelcompleted/' + thaistudent + '/' + facultyid + '/' + levelid + '/' + deptid + '/' + groupid + '/' + year);
  },
  getStatisticNotRegis(thaistudent, facultyid, deptid, groupid, year,level) {
    // console.log("api==",thaistudent, facultyid, deptid, groupid, year,level)
    return instance.get('statistic/notregis/' + thaistudent + '/' + facultyid + '/' + deptid + '/' + groupid + '/' + year + '/' + level);
  },
  getExcelNotRegis(thaistudent, facultyid, deptid, groupid, year) {
    return instance.get('statistic/excelnotregis/' + thaistudent + '/' + facultyid + '/' + deptid + '/' + groupid + '/' + year);
  },
  getStudent(studentid, acadyear) {
    return instance.get('statistic/getstudent/' + studentid + '/' + acadyear);
  },
  getStatisticSearch() {
    return instance.get('statistic/search');
  },
  getStatisticCountry() {
    return instance.get('statistic/country');
  }
};
